import { FC } from 'react';

import { Popover, PopoverBody, PopoverContent, PopoverTrigger, rem, useDisclosure } from '@bonusly/design-system';
import { Permission, ProtectedContent } from '@bonusly/who-am-i';

import { useUserProfile } from '../../hooks/useUserProfile';
import AuthButton from '../Auth/AuthButton';
import { NavDivider } from './NavDivider';
import { NavGroup } from './NavGroup';
import { NavMenuAdminButton } from './NavMenuAdminButton';
import { NavMenuBanner } from './NavMenuBanner';
import { NavMenuButton } from './NavMenuButton';
import { NavMenuHeader } from './NavMenuHeader';
import { NavMenuOptionsDesktop } from './NavMenuOptionsDesktop';
import { NavMenuOptionsMobile } from './NavMenuOptionsMobile';

export interface NavMenuProps {
	displayFor?: string;
}

export const NavMenu: FC<NavMenuProps> = ({ displayFor }) => {
	const { user } = useUserProfile();
	const { isOpen, onClose, onToggle } = useDisclosure();

	const isMobile = displayFor === 'mobile';

	const handleClick = () => {
		onToggle();
	};

	const handleClose = () => {
		onClose();
	};

	return (
		<Popover placement="bottom-end" isLazy onClose={handleClose} isOpen={isOpen}>
			{({ onClose }) => {
				return (
					<>
						<PopoverTrigger>
							<NavMenuButton isMobile={isMobile} isOpen={isOpen} onClick={handleClick} user={user} />
						</PopoverTrigger>

						<PopoverContent borderColor="gray.50" maxW={rem(295)}>
							<PopoverBody as="ul" px={0} py={1}>
								<NavGroup>
									<NavMenuHeader user={user} />
								</NavGroup>

								{isMobile ? (
									<ProtectedContent permissions={Permission.CanGiveRecognition}>
										<NavMenuBanner mt={1} mx={3} mb={2} />
									</ProtectedContent>
								) : null}

								<NavDivider mt={0} />

								{isMobile ? <NavMenuOptionsMobile onClose={onClose} /> : <NavMenuOptionsDesktop onClose={onClose} />}

								<NavGroup>
									<AuthButton />
								</NavGroup>

								{!isMobile && (
									<ProtectedContent permissions={Permission.CanViewAdmin}>
										<NavDivider />
										<NavGroup px={3} py={3}>
											<NavMenuAdminButton />
										</NavGroup>
									</ProtectedContent>
								)}
							</PopoverBody>
						</PopoverContent>
					</>
				);
			}}
		</Popover>
	);
};
